module.exports = __webpack_public_path__ + "static/media/country-dropdown-header.ffa4395b.png";